import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tw-w-full tw-flex tw-flex-col"
  }, [_vm.editor ? _c(VCard, {
    staticClass: "tw-w-full tw-flex tw-flex-col",
    style: [{
      borderColor: _vm.borderColor
    }, {
      borderWidth: _vm.hasError ? '2px' : 'auto'
    }],
    attrs: {
      "outlined": ""
    }
  }, [_c(VCard, {
    staticClass: "tw-flex tw-flex-wrap tw-px-2 tw-py-3",
    staticStyle: {
      "border-radius": "4px 4px 0 0 !important",
      "gap": "10px",
      "border-bottom-style": "solid"
    },
    style: {
      borderBottomColor: `${_vm.borderColor} !important`,
      borderBottomWidth: _vm.hasError ? '2px' : '1px'
    },
    attrs: {
      "color": _vm.$vuetify.theme.dark ? '' : 'white lighten-5',
      "dense": "",
      "flat": "",
      "tile": ""
    }
  }, [_c('div', {
    staticClass: "tw-flex tw-flex-wrap tw-items-center",
    staticStyle: {
      "gap": "5px"
    }
  }, [_vm.showElement('font-size') ? _c(VSelect, {
    staticClass: "tiptap-font-size-select",
    attrs: {
      "items": _vm.fontSizeList,
      "value": _vm.selectedFontSize,
      "dense": "",
      "filled": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.onFontSizeSelect
    }
  }) : _vm._e(), _vm.showElement('bold') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive('bold'),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.editor.chain().focus().toggleBold().run();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-bold")])], 1) : _vm._e(), _vm.showElement('italic') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive('italic'),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.editor.chain().focus().toggleItalic().run();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-italic")])], 1) : _vm._e(), _vm.showElement('link') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive('link'),
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.addLink
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-link-variant")])], 1) : _vm._e(), _vm.showElement('direction') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive({
        dir: 'ltr'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.setTextDirection('ltr');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-pilcrow-arrow-right")])], 1) : _vm._e(), _vm.showElement('direction') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive({
        dir: 'rtl'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.setTextDirection('rtl');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-pilcrow-arrow-left")])], 1) : _vm._e(), _vm.showElement('underline') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive('underline'),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.editor.chain().focus().toggleUnderline().run();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "15"
    }
  }, [_vm._v("mdi-format-underline")])], 1) : _vm._e(), _vm.showElement('strike') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive('strike'),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.editor.chain().focus().toggleStrike().run();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "15"
    }
  }, [_vm._v("mdi-format-strikethrough")])], 1) : _vm._e(), _vm.showElement('quote') ? _c(VBtn, {
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-quote-close")])], 1) : _vm._e(), _vm.showElement('color') ? _c(VBtn, {
    attrs: {
      "color": _vm.colorIconColor,
      "outlined": _vm.isActive('textStyle'),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.colorPicker = !_vm.colorPicker;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'white' : '#6c757d',
      "size": "18"
    }
  }, [_vm._v("mdi-palette")]), _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      "value": _vm.editor.getAttributes('textStyle').color,
      "nudge-bottom": "105",
      "nudge-right": "10",
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on
      }) {
        return [_c('div', _vm._g({}, on))];
      }
    }], null, false, 2846668839),
    model: {
      value: _vm.colorPicker,
      callback: function ($$v) {
        _vm.colorPicker = $$v;
      },
      expression: "colorPicker"
    }
  }, [_c(VCard, [_c(VCardText, {
    staticClass: "tw-p-0"
  }, [_c(VColorPicker, {
    attrs: {
      "flat": "",
      "show-swatches": "",
      "swatches-max-height": "200px"
    },
    on: {
      "input": _vm.setColor
    },
    model: {
      value: _vm.color,
      callback: function ($$v) {
        _vm.color = $$v;
      },
      expression: "color"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm.showElement('history') ? _c(VDivider, {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "tw-flex tw-flex-wrap tw-items-center",
    staticStyle: {
      "gap": "5px"
    }
  }, [_vm.showElement('history') ? _c(VBtn, {
    attrs: {
      "disabled": !_vm.editor.can().undo(),
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.undo
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-undo")])], 1) : _vm._e(), _vm.showElement('history') ? _c(VBtn, {
    attrs: {
      "disabled": !_vm.editor.can().redo(),
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.redo
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-redo")])], 1) : _vm._e()], 1), _c(VDivider, {
    attrs: {
      "vertical": ""
    }
  }), _c('div', {
    staticClass: "tw-flex flex-wrap tw-items-center",
    staticStyle: {
      "gap": "10px"
    }
  }, [_c('div', {
    staticClass: "tw-flex",
    staticStyle: {
      "gap": "5px"
    },
    attrs: {
      "dir": "ltr"
    }
  }, [_vm.showElement('list-bulleted') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.editor.isActive('bulletList') && !_vm.isActive({
        dir: 'rtl'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.addBullet
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-list-bulleted")])], 1) : _vm._e(), _vm.showElement('list-bulleted') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.editor.isActive('bulletList') && _vm.isActive({
        dir: 'rtl'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.addRtlBullet
    }
  }, [_c(VIcon, {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-list-bulleted")])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "tw-flex",
    staticStyle: {
      "gap": "5px"
    },
    attrs: {
      "dir": "ltr"
    }
  }, [_vm.showElement('list-numbered') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.editor.isActive('orderedList') && !_vm.isActive({
        dir: 'rtl'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.addNumberedList
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-list-numbered")])], 1) : _vm._e(), _vm.showElement('list-numbered') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.editor.isActive('orderedList') && _vm.isActive({
        dir: 'rtl'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.addRtlNumberedList
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-list-numbered-rtl")])], 1) : _vm._e()], 1)]), _c(VDivider, {
    attrs: {
      "vertical": ""
    }
  }), _c('div', {
    staticClass: "tw-flex flex-wrap tw-items-center"
  }, [_c('div', {
    staticClass: "tw-flex",
    staticStyle: {
      "gap": "5px"
    },
    attrs: {
      "dir": "ltr"
    }
  }, [_vm.showElement('align') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive({
        textAlign: 'left'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.setTextAlignment('left');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-align-left")])], 1) : _vm._e(), _vm.showElement('align') ? _c(VBtn, {
    attrs: {
      "outlined": _vm.isActive({
        textAlign: 'center'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.setTextAlignment('center');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-tw-items-center")])], 1) : _vm._e(), _vm.showElement('align') ? _c(VBtn, {
    staticStyle: {
      "padding": "2px"
    },
    attrs: {
      "outlined": _vm.isActive({
        textAlign: 'right'
      }),
      "icon": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.setTextAlignment('right');
      }
    }
  }, [_c(VIcon, {
    staticClass: "m-1",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-format-align-right")])], 1) : _vm._e()], 1)]), _vm.showElement('resizable_image') ? _c(VDivider, {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _vm.showElement('resizable_image') ? _c(VBtn, {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.addImage
    }
  }, [_c(VIcon, {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("mdi-image-area")])], 1) : _vm._e()], 1), _c('editor-content', {
    ref: "editorContent",
    staticClass: "tiptap-editor-input tw-px-4 tw-pt-4",
    staticStyle: {
      "border": "none",
      "outline": "none",
      "font-size": "1.2em"
    },
    style: {
      backgroundColor: _vm.editorPlaceholderColor
    },
    attrs: {
      "editor": _vm.editor
    }
  }), _c(VSnackbar, {
    attrs: {
      "color": _vm.inputAlertType
    },
    model: {
      value: _vm.inputAlert.open,
      callback: function ($$v) {
        _vm.$set(_vm.inputAlert, "open", $$v);
      },
      expression: "inputAlert.open"
    }
  }, [_vm._v(_vm._s(_vm.inputAlertMessage))])], 1) : _vm._e(), !_vm.data.hideDetails || _vm.hasError ? _c('span', {
    staticClass: "ps-3 tw-pb-2 tw-mt-1",
    staticStyle: {
      "font-size": "12px",
      "color": "var(--v-error-base)",
      "min-height": "25px"
    }
  }, [_vm._v(" " + _vm._s(_vm.hasError ? _vm.getMessages : '') + " ")]) : _vm._e(), _c('input', {
    staticClass: "tw-hidden",
    attrs: {
      "id": _vm.imageInputId,
      "accept": "image/jpeg, image/png, image/jpg, image/gif, image/webp, image/svg+xml",
      "type": "file"
    },
    on: {
      "change": _vm.onImageReady
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };